import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import {
  clearPendingDownload,
  publicDownloadPath,
  readPendingDownload
} from '../../lib/public/pendingDownload'
import AuthPage from './AuthPage'
import Logo from '../common/Logo'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Devolve à avaliação pública quem começou a se cadastrar para baixá-la: o
 * Google OAuth e o link de confirmação de e-mail terminam em /app. Apaga a
 * intenção ao montar, então a retomada acontece uma única vez.
 */
const ResumePendingDownload: React.FC<{ slug: string }> = ({ slug }) => {
  useEffect(() => {
    clearPendingDownload()
  }, [])
  return <Navigate to={publicDownloadPath(slug)} replace />
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth()

  // Show loading screen while auth is initializing
  if (loading) {
    // dark:bg-ink-900 é obrigatório: .dark pode já estar no <html> antes do
    // auth resolver, e a paleta escura da marca seria invisível sobre cream
    return (
      <div className="min-h-screen bg-cream-50 dark:bg-ink-900 flex items-center justify-center">
        <div className="text-center">
          <Logo variant="lockup-vertical" size={64} className="mb-4" />
          <div className="w-8 h-8 border-4 border-terra-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-ink-500 dark:text-ink-300">Carregando...</p>
        </div>
      </div>
    )
  }

  // Show auth page if no user
  if (!user) {
    return <AuthPage />
  }

  const pendingDownloadSlug = readPendingDownload()
  if (pendingDownloadSlug) {
    return <ResumePendingDownload slug={pendingDownloadSlug} />
  }

  // Show main app if user is authenticated
  return <>{children}</>
}

export default ProtectedRoute